import colors from 'styles/theme/colors';

export default function ViewHistoryIcon({
  width = 16,
  height = 16,
  color = colors.black100,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g stroke={color} strokeWidth='0.875' strokeLinecap='round' strokeLinejoin='round'>
        <path d='M9 14.6666C10.2856 14.6666 11.5423 14.2854 12.6112 13.5712C13.6801 12.857 14.5132 11.8418 15.0052 10.6541C15.4972 9.46635 15.6259 8.15942 15.3751 6.89854C15.1243 5.63766 14.5052 4.47948 13.5962 3.57043C12.6872 2.66139 11.529 2.04233 10.2681 1.79152C9.00721 1.54072 7.70028 1.66944 6.51256 2.16141C5.32484 2.65338 4.30968 3.4865 3.59545 4.55542C2.88122 5.62434 2.5 6.88105 2.5 8.16663V8.66663' />
        <path d='M0.5 6.66467L2.5 8.66467L4.5 6.66467' />
        <path d='M8.5 4.16467V8.66467H12' />
      </g>
    </svg>
  );
}
